import { useQueryClient } from '@tanstack/react-query';
import { ResourceType } from '../../api/app.types';
import { useFilterContext } from '../state';
import useAdditionalAppIds from './useAdditionalAppIds';
import { graphQueryKeys } from '../../api/graph.api';

export default function useCachedResource(resourceType: ResourceType, id: string) {
  const queryClient = useQueryClient();
  const { showAllApps } = useFilterContext();
  const { additionalAppRegistrationIds, additionalEnterpriseApplicationIds } = useAdditionalAppIds();

  if (showAllApps) {
    switch (resourceType) {
      case ResourceType.AppRegistration:
        return queryClient
          .getQueryData(graphQueryKeys.getAppRegistrations)
          ?.pages.flatMap((page) => page.value)
          .find((app) => app && app.id === id);

      case ResourceType.EnterpriseApplication:
        return queryClient
          .getQueryData(graphQueryKeys.getEnterpriseApplications)
          ?.pages.flatMap((page) => page.value)
          .find((app) => app && app.id === id);
    }
  }

  switch (resourceType) {
    case ResourceType.AppRegistration: {
      const myAppRegistration = queryClient
        .getQueryData(graphQueryKeys.getMyAppRegistrations)
        ?.pages.flatMap((page) => page.value)
        .find((app) => app && app.id === id);

      return (
        myAppRegistration ??
        queryClient
          .getQueryData(graphQueryKeys.getAppRegistrationsInBatch(additionalAppRegistrationIds))
          ?.apps.find((app) => app.id === id)
      );
    }

    case ResourceType.EnterpriseApplication: {
      const myEnterpriseApplication = queryClient
        .getQueryData(graphQueryKeys.getMyEnterpriseApplications)
        ?.pages.flatMap((page) => page.value)
        .find((app) => app && app.id === id);

      return (
        myEnterpriseApplication ??
        queryClient
          .getQueryData(graphQueryKeys.getEnterpriseApplicationsInBatch(additionalEnterpriseApplicationIds))
          ?.apps.find((app) => app.id === id)
      );
    }
  }
}
